import React from 'react';
import { useTranslation } from 'react-i18next';
import logoLetterSvg from 'assets/logo-letter.svg';
import { formatLocalTime } from 'utils/formatDate';
import styles from './statsHeader.module.scss';

interface StatsHeaderProps {
  user: any;
}

const StatsHeader: React.FC<StatsHeaderProps> = ({ user }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.statsHeaderTitle}>
      <div className={styles.statsAvatarWrapper}>
        <div className={styles.statsAvatar}>
          <img
            src={logoLetterSvg}
            alt={t('statistics.avatarAlt')}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </div>
      </div>
      <div className={styles.statsUserInfo}>
        <div className={styles.statsUsername}>{user?.username || t('statistics.guest')}</div>
        <div className={styles.statsJoinDate}>
          {t('statistics.joined', {
            date: formatLocalTime(user?.createdAt, false, 'Feb 5, 2026'),
          })}
        </div>
      </div>
    </div>
  );
};

export default StatsHeader;
